import script from "./SupportAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportAdmin.vue?vue&type=script&setup=true&lang=js"

import "./SupportAdmin.vue?vue&type=style&index=0&id=012ae7f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012ae7f4"]])

export default __exports__